import React from 'react'
import { IReservationModel } from './ReservationModel'
import DataTable, { TableAction, TableColumn } from '../../../shared/components/DataTable'

type Props = {
  data: IReservationModel[]
  currentPage: number
  totalPages: number
  pageSize: number
  onPageSizeChange?: (size: number) => void
  onPageChange: (page: number) => void // Düzeltme: parametre tipi eklendi
  onEdit?: (reservation: IReservationModel) => void // Düzeltme: Edit fonksiyonu eklendi
  onDelete?: (reservation: IReservationModel) => void // Düzeltme: Delete fonksiyonu eklendi
  sortBy?: string // Düzeltme: Sort state'leri eklendi
  sortOrder?: 'asc' | 'desc'
  onSort?: (column: string, order: 'asc' | 'desc') => void
  loading?: boolean
}

export const ReservationTable: React.FC<Props> = ({
  data,
  currentPage,
  totalPages,
  pageSize,
  onPageSizeChange,
  onPageChange,
  onEdit,
  onDelete,
  sortBy,
  sortOrder,
  onSort,
  loading = false
}) => {
  const reservationColumns: TableColumn<IReservationModel>[] = [
    { key: 'startDate', label: 'Baş. Zaman', className: 'fw-semibold', sortable: true },
    { key: 'endDate', label: 'Bit. Zaman', className: 'fw-semibold', sortable: true },
    { key: 'vehicleGroupName', label: 'Araç Grubu' },
    { key: 'carPlate', label: 'Plaka', sortable: true },
    { key: 'brandName', label: 'Marka' },
    { key: 'modelType', label: 'Tipi' },
    { key: 'fuelType', label: 'Yakıt Tipi' },
    { key: 'transmission', label: 'Vites Tipi' },
    { key: 'customerFullName', label: 'Adı Soyadı' },
  ]

  // Düzeltme: TableAction'da IBranchModel tipini kullan
  const reservationActions: TableAction<IReservationModel>[] = [
    {
      label: 'Düzenle',
      icon: 'bi bi-pencil',
      className: 'btn-light-primary me-2',
      onClick: (reservation) => onEdit?.(reservation), // Düzeltme: Parent'tan gelen fonksiyon
    },
    {
      label: 'Sil',
      icon: 'bi bi-trash',
      className: 'btn-light-danger',
      onClick: (reservation) => onDelete?.(reservation), // Düzeltme: Parent'tan gelen fonksiyon
    },
  ]

  return (
    <DataTable
      data={data}
      columns={reservationColumns}
      actions={reservationActions}
      showPagination={true}
      currentPage={currentPage}
      totalPages={totalPages}
      pageSize={pageSize}
      onPageSizeChange={onPageSizeChange}
      onPageChange={onPageChange}
      sortBy={sortBy}
      sortOrder={sortOrder}
      onSort={onSort}
      loading={loading}
      emptyMessage='Henüz rezervasyon bulunamadı'
    />
  )
}